const bindDataAndCallFunctions = (
  selection,
  data,
  enterFn,
  updateFn,
  exitFn
) => {
  const update = selection.data(data, (d) => d.id);
  const enter = update.enter();
  const exit = update.exit();

  if (!enter.empty()) enterFn(enter);
  if (!update.empty()) updateFn(update);
  if (!exit.empty()) exitFn(exit);

  return update.merge(enter);
};

export { bindDataAndCallFunctions };
